module.exports =(function() {
  return function(context) {
    return (function() {
      var $c, $e, $o;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      $o.push("<footer class='bordered--top soft-half--ends text--center'>");
      if (this.createCompanyUrl) {
        $o.push("  <a class='js-create-company' href='" + ($e($c(this.createCompanyUrl))) + "' target='_blank' rel='noopener noreferrer'>");
        $o.push("    " + $c(I18n.t('web.companies.add_new_company')));
        $o.push("  </a>");
      } else {
        $o.push("  <a class='js-create-company'>");
        $o.push("    " + $c(I18n.t('web.companies.add_new_company')));
        $o.push("  </a>");
      }
      $o.push("</footer>");
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);
